import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL_DASHBOARD;

const apiDashboard = axios.create({
  baseURL: BASE_URL,
});

apiDashboard.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("cria-web@token-dashboard");

    if (
      token &&
      token !== "" &&
      JSON.parse(token) !== "null" &&
      JSON.parse(token) !== null
    ) {
      config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiDashboard.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response.status === 401 &&
      !originalRequest._retry &&
      (error.response.data?.msg === "Token has expired" ||
        error.response.data?.msg === "Missing Authorization Header")
    ) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem(
        "cria-web@refreshToken-dashboard"
      );

      if (
        refreshToken &&
        refreshToken !== "" &&
        JSON.parse(refreshToken) !== "null" &&
        JSON.parse(refreshToken) !== null
      ) {
        const parsedToken = `Bearer ${JSON.parse(refreshToken)}`;
        try {
          const { data } = await axios.get(
            "api/v1/auth/token/refresh",
            {
              baseURL: BASE_URL,
              headers: {
                Authorization: parsedToken,
              },
            }
          );

          const newAccessToken = data.access_token;
          localStorage.setItem(
            "cria-web@token-dashboard",
            JSON.stringify(newAccessToken)
          );
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axios(originalRequest);
        } catch (error) {}
      }
    }
    return Promise.reject(error);
  }
);

export default apiDashboard;
